<template>
  <div class="audit-qa-tab-wrapper">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item><a href="/">活动管理</a></el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
      <el-breadcrumb-item>活动详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="audit-qa-tab-list-content">
      <div class="audit-qa-tab-list">
        <div class="audit-qa-tab-list-header">待审核列表</div>
        <div class="audit-qa-tab-select">
          <div class="audit-qa-tab-input">
            <el-input
                class="qa-tab-list-search inline-input"
                v-model="qaTabSearch"
                placeholder="请输入内容"
                :clearable="true"
                @change="listAuditQaTab">
              <i class="el-icon-search el-input__icon" slot="suffix"></i>
            </el-input>
          </div>
        </div>
        <div class="infinite-list-wrapper" style="overflow:auto">
          <ul class="audit-qa-tab-title-list" v-infinite-scroll="load">
            <li class="audit-qa-tab-title-wrapper" v-for="auditQaTab in auditQaTabList" :key="auditQaTab.id"
                @click="handleAuditQaTabClick(auditQaTab)">
              <div v-if="auditQaTab.tabName" class="qa-tab-title">{{auditQaTab.tabName}}</div>
              <div v-else class="qa-tab-title"><span>当前回复未添加标题</span></div>
            </li>
          </ul>
          <p v-if="loading">加载中...</p>
          <p v-if="noMore">没有更多了</p>
        </div>
      </div>
      <div class="audit-qa-tab">
        <div class="audit-qa-tab-header">待审核标签页详情</div>
        <div v-if="auditQaTabList.length > 0">
          <div>
            {{auditQaTab.tabName}}
          </div>
          <div class="audit-qa-tab-content"></div>
          <div class="audit-qa-tab-button">
            <el-button @click="handleReject" plain>否决</el-button>
            <el-button @click="handleAdopt" plain>采用</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {auditQaTab, fetchAuditQaTab, listAuditQaTab} from "@/api/qa/qa";

  export default {
    name: "qa-tab-audit",
    data() {
      return {
        pageSize: 10,
        total: 0,
        hasNext: false,
        currentPage: 1,
        auditQaTabList: [],
        /**
         * 当前正进行审核的标签页信息
         */
        auditQaTab: {},
        qaTabSearch: '',
        loading: false
      }
    },
    methods: {
      handlePageChange(page) {
        this.currentPage = page;
        this.listAuditQaTab();
      },
      handleAdopt() {
        // 问答回复信息的状态  0 待审核  1 审核通过  2 审核未通过  3 被举报后下线
        auditQaTab({id: this.auditQaTab.id, dataStatus: 1}).then(res => {
            if (res != null) {
              console.log(res);
              this.listAuditQaTab();
            }
          }
        );
      },
      handleReject() {
        // 问答回复信息的状态  0 待审核  1 审核通过  2 审核未通过  3 被举报后下线
        auditQaTab({id: this.auditQaTab.id, dataStatus: 2}).then(
          res => {
            if (res != null) {
              console.log(res);
              this.listAuditQaTab();
            }
          }
        );
      },
      fetchAuditQaTab(tabId) {
        fetchAuditQaTab(tabId).then(res => {
          this.auditQaTab = res.data.data;
        });
      },
      handleAuditQaTabClick(auditQaTab) {
        // 查询问答标签页信息
        this.fetchAuditQaTab(auditQaTab.id);
      },
      /**
       * 获取待审核的问答标签页列表
       */
      listAuditQaTab() {
        listAuditQaTab({
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            data: {keyword: this.qaTabSearch}
          }
        ).then(res => {
            if (res.data.data != null) {
              this.auditQaTabList = res.data.data.list;
              this.total = res.data.data.total;
              this.hasNext = res.data.data.hasNext;
              if (this.auditQaTabList.length > 0) {
                this.fetchAuditQaTab(this.auditQaTabList[0].id);
              }
            }
          }
        );
      },
      load() {
        this.loading = true
        setTimeout(() => {
          this.count += 2
          this.loading = false
        }, 2000)
      }
    },
    computed: {
      noMore() {
        return this.count >= 20
      },
      disabled() {
        return this.loading || this.noMore
      }
    },
    created() {
      this.listAuditQaTab();
    }
  }
</script>

<style lang="scss" scoped>
  .audit-qa-tab-wrapper {

  }

  .audit-qa-tab-list-content {
    padding-top: 20px;
    display: flex;
  }

  .audit-qa-tab-list {
    width: 600px;
  }

  .audit-qa-tab-list-header {
    font-weight: 600;
    font-size: 24px;
    line-height: 40px;
    color: #212121;
    word-break: break-word;
    padding-bottom: 20px;
  }

  .audit-qa-tab-input {
    //margin-top: 20px;

    .qa-tab-list-search {
      width: 400px;
    }
  }


  .audit-qa-tab-header {
    font-weight: 600;
    font-size: 24px;
    line-height: 40px;
    color: #212121;
    word-break: break-word;
    padding-bottom: 20px;
  }

  .audit-qa-tab-button {
    padding-top: 10px;
  }

  .audit-qa-tab-title-list {
    padding: 20px 0 5px;
    height: 300px;

    .audit-qa-tab-title-wrapper {
      margin-bottom: 15px;
      cursor: pointer;
    }
  }

  .page-wrapper {
    //position: absolute;
    //bottom: 0;
    //width: 100%;
    //display: flex;
    //justify-content: center;
  }

  .audit-qa {
    height: 50px;
    padding-bottom: 10px;
    cursor: default;
  }

  .qa-content {
    cursor: pointer;
  }

  .audit-qa-tab {
    margin-left: 20px;
    max-width: 600px;
  }

  .audit-qa-tab-content {
    margin-top: 20px;
  }
</style>
